import(/* webpackMode: "eager" */ "C:\\website\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager" */ "C:\\website\\src\\app\\globals.css");
;
import(/* webpackMode: "eager" */ "C:\\website\\node_modules\\next\\font\\google\\target.css?{\"path\":\"src\\\\app\\\\layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true,\"fallback\":[\"system-ui\",\"sans-serif\"],\"adjustFontFallback\":true,\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\website\\src\\app\\layout.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\website\\src\\components\\CookieConsent.tsx");
